import { motion } from 'framer-motion'
import { useContent } from '@/contexts/ContentContext'

export default function Hero() {
  // Obtendo diretamente as seções do contexto para garantir que as atualizações sejam recebidas
  const { sections } = useContent()
  
  // Encontrando a seção hero diretamente do array de seções
  const heroSection = sections.find(section => section.id === 'hero')
  
  console.log('Hero Component - Sections:', sections)
  console.log('Hero Component - Hero Section:', heroSection)
  return (
    <section id="hero" className="relative min-h-screen bg-light-primary dark:bg-dark-primary brand:bg-brand-primary">
      {/* Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="absolute top-1/2 left-1/2 min-h-full min-w-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 object-cover opacity-50"
        >
          <source src="/videos/hero/hero-background.mp4" type="video/mp4" />
          Seu navegador não suporta vídeo em background.
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-40 dark:bg-opacity-60 brand:bg-opacity-30" />
      </div>

      {/* Content */}
      <div className="relative flex min-h-screen items-center">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-lg rounded-lg bg-black/30 p-8 backdrop-blur-sm dark:bg-dark-secondary/20 brand:bg-brand-secondary/40"
          >
            <h1>
              <span className="block text-4xl font-extrabold text-white dark:text-dark-primary brand:text-brand-light sm:text-5xl">
                {heroSection?.content.title || 'Serralheria e Estruturas'}
              </span>
              <span className="mt-2 block text-3xl font-bold text-primary-600 dark:text-dark-accent brand:text-brand-accent sm:text-4xl">
                {heroSection?.content.subtitle || 'Metálicas de Precisão'}
              </span>
            </h1>

            <div className="mt-6 space-y-2">
              <p className="text-lg font-medium text-white dark:text-dark-primary brand:text-brand-light">
                {heroSection?.content.description || 'Projetos sob medida para sua necessidade.'}
              </p>
              <p className="text-base text-white/90 dark:text-dark-secondary brand:text-brand-secondary">
                {heroSection?.content.subDescription || 'Portões, móveis industriais, projetos especiais e manutenções.'}
              </p>
              <p className="text-sm text-white/80 dark:text-dark-secondary/60 brand:text-brand-secondary/80">
                Qualidade e durabilidade em cada detalhe.
              </p>
            </div>

            <motion.a
              href="#contato"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="mt-6 inline-block w-full rounded-md bg-primary-600 px-6 py-3 text-center text-sm font-semibold uppercase tracking-wider text-white transition-colors hover:bg-primary-700 dark:bg-dark-accent dark:hover:bg-primary-700 brand:bg-brand-accent brand:hover:bg-brand-accent/90 sm:w-auto"
            >
              {heroSection?.content.cta || 'Orçamento sem compromisso'}
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  )
} 